const sections = [
  {
    icon: "ri-time-line",
    title: "営業時間",
    items: [
      "TEL予約　9:00〜19:00",
      "公式LINE予約　24時間対応",
    ],
  },
  {
    icon: "ri-price-tag-3-line",
    title: "駐車場料金",
    items: [
      "駐車料金は一律、どんな車両でも3,000円です。",
      "送迎代金は無料です。",
    ],
  },
  {
    icon: "ri-wallet-3-line",
    title: "お支払方法",
    items: [
      "ご来店いただいたときに前金でのお支払いとなります。",
      "現金、PayPay、d払い、各種クレジット払いからお選びいただけます。",
    ],
  },
  {
    icon: "ri-roadster-line",
    title: "送迎経路",
    items: [
      "往路はコカ・コーラゲート前の歩道に停車し、そこで降車いただきます。",
      "往路での乗車は、ポリー駐車場前にてお願いします。",
      "復路はバス出入り口付近（ポリー駐車場さん右折看板の反対側）での乗車となります。（乗車場所は往路の車内でご説明します。）",
      "エスコンフィールドへの送迎時間は5〜10分程度で到着します。",
      "※今後の道路状況により送迎経路が変わる可能性があります。",
    ],
  },
  {
    icon: "ri-error-warning-line",
    title: "注意事項",
    items: [
      "試合終了後、指定場所へお越しください。",
      "時間は決まっていないため集合時間はありませんが、2便・3便と続く場合は車の人数規定により定員になり次第、次便となります。（今後、多忙になり次第時間の規制を設ける場合があります。）",
      "お客様の入り具合により、来ていただいた順番で戻ります。",
      "通常、途中退場の場合はご自身で駐車場まで来ていただきますが、お客様の人数により途中でもお迎えに上がることは可能です。（お迎えの人数が多い場合は途中退場が難しい場合があります。）",
      "例外：体調不良や怪我など予測できない場合。",
    ],
  },
  {
    icon: "ri-calendar-close-line",
    title: "キャンセルについて",
    items: [
      "キャンセル料金はいただいておりません。",
      "キャンセルの旨をお伝えいただければ対応いたします。",
    ],
  },
  {
    icon: "ri-calendar-event-line",
    title: "休日",
    items: [
      "毎週月曜日",
      "※祝日の振替休日（月曜日）は試合が開催されるため営業しています。",
      "※エスコンフィールドでのイベント（ライブ・コンサート・試合・各種イベント）で変動する場合があります。",
    ],
  },
];

export default function FooterGuide() {
  return (
    <div className="rounded-2xl border border-background-50/10 bg-background-50/5 px-5 md:px-8 py-7 md:py-8">
      <div className="flex items-center gap-3">
        <span className="w-9 h-9 rounded-full bg-secondary-500 text-foreground-950 flex items-center justify-center shrink-0">
          <i className="ri-information-line text-lg" />
        </span>
        <div>
          <h4 className="font-heading text-lg md:text-xl text-background-50">
            アネットパーキングのご利用案内
          </h4>
          <p className="text-background-300 text-xs mt-0.5">
            下記の内容をご確認のうえ、ご予約ください。
          </p>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-7">
        {sections.map((s) => (
          <div key={s.title}>
            <div className="flex items-center gap-2">
              <span className="w-6 h-6 flex items-center justify-center text-secondary-200 shrink-0">
                <i className={`${s.icon} text-base`} />
              </span>
              <span className="text-sm font-semibold text-background-50 whitespace-nowrap">
                {s.title}
              </span>
            </div>
            <ul className="mt-3 space-y-2">
              {s.items.map((it) => (
                <li
                  key={it}
                  className="flex gap-2 text-xs md:text-sm text-background-100/90 leading-relaxed"
                >
                  <i className="ri-checkbox-blank-circle-fill text-[5px] mt-[7px] text-secondary-300 shrink-0" />
                  <span>{it}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}